import Chip from "@/components/primitives/chip";
import { StatComparison } from "./stat-comparison-data";
import { forceValue } from "common";

function StatComparisonChart({
  data,
  awayColor,
  homeColor,
}: {
  data: StatComparison[] | undefined;
  awayColor: string;
  homeColor: string;
}) {
  return (
    <>
      {data?.map((section, i) => (
        <div key={`stat-comparison-${i}`}>
          <div className="mb-5">
            {section.group && (
              <Group key={`stat-comparison-group-${i}`}>{section.group}</Group>
            )}
            {section.items.map((item, i) => (
              <div
                key={`stat-comparison-item-${i}`}
                className="flex flex-col gap-0 desktop-grid:gap-2 mb-[14px] desktop-grid:mb-5"
              >
                <div className="flex justify-between items-center text-title-bold text-secondary-100 h-[40px]">
                  <div className="flex flex-row items-center gap-3 pl-1 uppercase">
                    {item.away.title && <span>{item.away.title}</span>}
                    {item.away.label && (
                      <div className="flex justify-center items-center py-1 px-2 bg-surface-500 rounded-sm text-label-lg text-secondary-400 normal-case">
                        {forceValue(item.away.label, "tbd")}
                      </div>
                    )}
                  </div>
                  <div className="uppercase text-center">{item.label}</div>
                  <div className="flex flex-row items-center gap-3 pr-1 uppercase">
                    {item.home.title && <span className="order-2">{item.home.title}</span>}
                    {item.home.label && (
                      <span className="order-1 flex justify-center items-center py-1 px-2 bg-surface-500 rounded-sm text-label-lg text-secondary-400 normal-case">
                        {forceValue(item.home.label, "tbd")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-full flex gap-1">
                  <StackedBar
                    color={
                      item.away.value > 0 ? `#${awayColor}` : "var(--secondary-600)"
                    }
                    height={0.625}
                    width={(item.away.value === 0 && item.home.value > 0) ? 5 : (item.away.value > 0 && item.home.value === 0) ? 100 : item.away.value > 0 ? item.away.value : 50}
                  />
                  <StackedBar
                    color={
                      item.home.value > 0 ? `#${homeColor}` : "var(--secondary-700)"
                    }
                    height={0.625}
                    width={(item.home.value === 0 && item.away.value > 0) ? 5 : (item.home.value > 0 && item.away.value === 0) ? 100 : item.home.value > 0 ? item.home.value : 50}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
}

function StackedBar({
  color,
  height,
  width,
}: {
  color: string;
  height: number;
  width: number;
}) {

  return (
    <div
      className="rounded-md"
      style={{
        backgroundColor: `${color}`,
        height: `${height}rem`,
        width: `${width}%`,
      }}
    ></div>
  );
}
function Group({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-row items-center my-5">
      <div className="w-full">
        <hr />
      </div>
      <div className="px-6">
        <Chip color="dark" size="md">
          <span className="uppercase text-label-lg-bold">{children}</span>
        </Chip>
      </div>
      <div className="w-full">
        <hr />
      </div>
    </div>
  );
}

export default StatComparisonChart;
